import investmentCompare from "./investmentCompare"
import percentCompare from "./percentCompare"
import sparkline from "./sparkline"
import comparePie from "./comparePie"
import autoGroupPie from "./autoGroupPie"

export default {
  investmentCompare,
  sparkline,
  comparePie,
  autoGroupPie,
  percentCompare
}
